import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './EventDetailScreen.css';
import Breadcrumb from '../../components/Breadcrumb';
import EventFeaturedImage from './components/EventFeaturedImage';
import EventHeader from './components/EventHeader';
import EventMeta from './components/EventMeta';
import VideoEmbed from '../../components/VideoEmbed';
import EventActions from './components/EventActions';
import RelatedEvents from './components/RelatedEvents';
import { useEventDetail, useAddToCalendar } from './hooks/useEventData';
import { LoadingState, ErrorState } from '../../components';

function EventDetailScreen() {
  const { id } = useParams();
  const { event, relatedEvents, loading, error } = useEventDetail(id);
  
  const handleAddToCalendar = useAddToCalendar(event ? {
    title: event.title,
    date: event.date,
    dateEnd: event.date_end,
    hourStart: event.hour_start,
    hourEnd: event.hour_end,
    place: event.place,
    description: event.description
  } : null);

  if (loading) {
    return (
      <div className="event-detail-screen">
        <div className="event-detail-container">
          <LoadingState message="Caricamento evento..." />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="event-detail-screen">
        <div className="event-detail-container">
          <Breadcrumb to="/events" label="Torna agli eventi" />
          <ErrorState 
            message={error}
            onRetry={() => window.location.reload()}
            retryText="Ricarica"
          />
        </div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="event-detail-screen">
        <div className="event-detail-container">
          <Breadcrumb to="/events" label="Torna agli eventi" />
          <div className="not-found-container">
            <i className="fa-regular fa-calendar"></i>
            <h2>Evento non trovato</h2>
            <p>L'evento che stai cercando non esiste o è stato rimosso.</p>
            <a href="/events" className="back-button">Torna agli eventi</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="event-detail-screen">
      <div className="event-detail-container">
        <Breadcrumb to="/events" label="Torna agli eventi" />

        <div className="event-detail">
          <EventFeaturedImage 
            src={event.photo_link}
            alt={event.title}
            date={event.date}
          />

          <div className="event-detail-content">
            <EventHeader 
              title={event.title}
              topic={event.topic}
            />

            <EventMeta 
              date={event.date}
              dateEnd={event.date_end}
              hourStart={event.hour_start}
              hourEnd={event.hour_end}
              place={event.place}
              host={event.host}
            />

            <div className="event-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(event.description) }} />

            <VideoEmbed 
              src={event.video_link}
              title={event.title}
            />

            <EventActions 
              eventLink={event.event_link}
              onAddToCalendar={handleAddToCalendar}
            />
          </div>
        </div>

        {relatedEvents && relatedEvents.length > 0 && (
          <RelatedEvents events={relatedEvents} />
        )}
      </div>
    </div>
  );
}

export default EventDetailScreen;
